import React, { memo } from 'react';

import { PageError } from '@/components/Error';
import { FormProps } from '@/components/Form';
import Loader from '@/components/Loader';
import useFile from '@/modules/tasks/views/TasksDashboard/hooks/useFile';

import Editor from './components/Editor';
import { ListEditorFormValues } from './components/Editor/config';

function ListEditorContainer({
  setFormikSubmit,
  onSubmit,
  file,
  fetching,
  error,
  initialValues,
}: {
  setFormikSubmit: FormProps<ListEditorFormValues>['setSubmitRef'];
  onSubmit: FormProps<ListEditorFormValues>['onSubmit'];
  file?: ReturnType<typeof useFile>['file'];
  fetching: boolean;
  error?: any;
  initialValues?: Partial<ListEditorFormValues>;
}) {
  if (fetching) {
    return <Loader />;
  }

  if (error) {
    return <PageError error={error} />;
  }

  return (
    <Editor
      file={file}
      initialValues={initialValues}
      setFormikSubmit={setFormikSubmit}
      onSubmit={onSubmit}
    />
  );
}

export default memo(ListEditorContainer);
